// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3X3OG","footer":"ModalFilter_footer__2bVwH"};